import { useState } from "react";
import { useTranslation } from "react-i18next";
import { CircleHelp } from "lucide-react";
import { Button } from "@/components/ui/button";
import { cn } from "@/lib/utils";
import { useModuleGuide } from "@/hooks/use-module-guide";
import { GuideVideoModal } from "./guide-video-modal";

export const GuideHelpButton: React.FC = () => {
  const { t } = useTranslation();
  const { guide } = useModuleGuide();
  const [open, setOpen] = useState(false);

  if (!guide) return null;

  return (
    <>
      <Button
        variant="ghost"
        size="icon"
        title={guide.title}
        aria-label={t("guides.watch_video", { defaultValue: "Regarder la vidéo" })}
        onClick={() => setOpen(true)}
        className={cn(
          "text-muted-foreground hover:text-foreground",
          "hover:bg-muted rounded-full transition-all duration-200",
          "hover:scale-110"
        )}
      >
        <CircleHelp className="h-5 w-5" />
      </Button>
      <GuideVideoModal guide={guide} open={open} onOpenChange={setOpen} />
    </>
  );
};
